<template>
    <span>

        <base-button v-if="isPending || isRejected" size="md" :class="'btn_extra_small btn-primary'"
            @click.native="viewApproveItem">
            <i class="tim-icons icon-lock-circle">{{ approveText }}</i>
        </base-button>
        <base-button v-if="isPending" size="md" :class="'btn_extra_small btn-danger'" @click.native="viewRejectItem">
            <i class="tim-icons icon-lock-circle">{{ rejectText }}</i>
        </base-button>

        <!-- small modal -->
        <modal :show.sync="modals.notice" v-on:close="closeModal" headerClasses="justify-content-center" type="notice">
            <h4 slot="header" class="title title-up">{{ modals.header }}</h4>
            <hr />
            <div class="container">
                <el-alert class="mb-2" v-if="!userRoles.length && !isRejecting"
                    title="At least one User Role required." type="error" />
                <el-alert v-if="!user.emailConfirmed && !isRejecting" title="User's email has not been verified."
                    type="error" />

                <div class="row">
                    <div v-if="isRejecting" class="col-md-12">
                        Reject user {{ `${user.firstName} ${user.lastName}` }} at {{ user.email }}?
                    </div>
                    <div v-else class="col-md-12">
                        <div v-if="!isPartnerNation" class="col-md-12">
                            <base-checkbox v-for="(checkbox, index) in nonePartnerNationCheckboxes" :key="index" class="mb-3" v-model="checkbox.checked" required>
                                {{ checkbox.name }}
                            </base-checkbox>
                        </div>
                        <div v-else class="col-md-12">
                            <base-checkbox v-for="(checkbox, index) in partnerNationCheckboxes" :key="index" class="mb-3" v-model="checkbox.checked" required>
                                {{ checkbox.name }}
                            </base-checkbox>
                        </div>
                    </div>
                    <div v-if="error.value" class="col-md-12">
                        <label class="error">{{ error.text }}</label>
                    </div>
                </div>
            </div>
            <template slot="footer">
                <div class="container alert_footer">
                    <base-button type="danger" class="alert_footer_button btn_extra_small btn_info mr-4"
                        @click.native="closeModal">
                        Close
                    </base-button>
                    <base-button :disabled="!userRoles.length && !isRejecting || !user.emailConfirmed && !isRejecting"
                        type="primary" class="alert_footer_button btn_extra_small btn_info"
                        @click.native="modals.submitAction">
                        Confirm
                    </base-button>
                </div>
            </template>
        </modal>
    </span>
</template>

<script>
import {
    mapGetters,
    mapActions
} from "vuex";
import {
    BaseButton,
    Modal
} from "src/components";
import Util from "@/util/util";
import { Alert } from "element-ui";
import BaseCheckbox from '../../../components/Inputs/BaseCheckbox.vue';

export default {
    name: "approval-modal",

    props: {
        id: {
            type: String,
        },
        approveText: {
            type: String,
            default: 'APPROVE',
        },
        rejectText: {
            type: String,
            default: 'REJECT',
        },
        user: {
            type: Object
        },
        organizationId: {
            type: Number,
            default: 48
        }
    },
    data() {
        return {
            modals: {
                notice: false,
                header: null,
                submitAction: null
            },
            isRejecting: false,
            approval: {
                id: null,
                SponsorNote: ''
            },
            nonePartnerNationCheckboxes: [
                {
                    "id": 1,
                    "name": 'Are the correct "roles" assigned to the user?',
                    "checked": false
                },
                {
                    "id": 2,
                    "name": 'Has the User been trained IAW CJCSI 2120.01E, Enclosure A, Para 9?',
                    "checked": false
                },
                {
                    "id": 3,
                    "name": 'Is the correct "organization" selected for the user?',
                    "checked": false
                }, {
                    "id": 4,
                    "name": 'Has the user confirmed their e-mail address?',
                    "checked": false
                }
            ],
            partnerNationCheckboxes: [
                {
                    "id": 1,
                    "name": 'Has the User been trained IAW CJCSI 2120.01E, Enclosure A, Para 9?',
                    "checked": false
                },
                {
                    "id": 2,
                    "name": 'Has the signed Partner Nation Appoinment Memo been uploaded?',
                    "checked": false
                },
                {
                    "id": 3,
                    "name": 'Is the correct Country displayed for the user?',
                    "checked": false
                }, {
                    "id": 4,
                    "name": 'Has the user confirmed their e-mail address?',
                    "checked": false
                }
            ],
            error: {
                value: false,
                text: "All four checkboxes must be selected in order to approve the user."
            }
        };
    },
    components: {
        BaseButton,
        Modal,
        BaseCheckbox,
        [Alert.name]: Alert,
    },
    computed: {
        ...mapGetters({
            // user: "users/user",
            authenticatedUserId: "authentication/authUserId",
            isPNManager: "authentication/isPNManager",
            isSponsor: "authentication/isSponsor",
        }),
        userRoles() {
            return this.user && this.user.roles ? this.user.roles : [];
        },
        isPending() {
            return this.user.approvalStatusName == "PENDING" ? true : false;
        },
        isApproved() {
            return this.user.approvalStatusName == "APPROVED" ? true : false;
        },
        isLocked() {
            return this.user.approvalStatusName == "LOCKED" ? true : false;
        },
        isRejected() {
            return this.user.approvalStatusName == "REJECTED" ? true : false;
        },
        isPartnerNation() {
            if (typeof this.user.roles !== 'undefined')
                return this.user.roles.indexOf('PartnerNation') === -1 ? false : true;
            return false;
        }
    },
    methods: {
        ...mapActions({
            approveUser: "users/approveUser",
            rejectUser: "users/rejectUser",
            getUser: "users/getUser",
            updateUser: "users/updateUserAdmin",
        }),
        closeModal() {
            this.modals.notice = false;
            this.clearCheckBoxes();
        },
        clearCheckBoxes() {
            if (!this.isPartnerNation) {
                for (let i = 0; i < this.nonePartnerNationCheckboxes.length; i++) {
                    this.nonePartnerNationCheckboxes[i].checked = false;
                }
            } else {
                for (let i = 0; i < this.partnerNationCheckboxes.length; i++) {
                    this.partnerNationCheckboxes[i].checked = false;
                }
            }
        },
        viewApproveItem() {
            let ctx = this;
            ctx.approval.id = ctx.id;
            ctx.modals.header = "APPROVE USER?";
            ctx.modals.submitAction = ctx.approve;
            ctx.isRejecting = false;
            ctx.modals.notice = true;
        },
        viewRejectItem() {
            let ctx = this;
            ctx.approval.id = ctx.id;
            ctx.modals.header = "REJECT USER?";
            ctx.modals.submitAction = ctx.reject;
            ctx.isRejecting = true;
            ctx.modals.notice = true;
        },
        approve(e) {
            if (!this.isPartnerNation) {
                for (let i = 0; i < this.nonePartnerNationCheckboxes.length; i++) {
                    if (!this.nonePartnerNationCheckboxes[i].checked) {
                        this.error.value = true;
                        return;
                    }
                }
            } else {
                for (let i = 0; i < this.partnerNationCheckboxes.length; i++) {
                    if (!this.partnerNationCheckboxes[i].checked) {
                        this.error.value = true;
                        return;
                    }
                }
            }

            this.$validator.validateAll().then(async (result) => {
                if (result) {
                    let roles = null;
                    if (this.user) {
                        roles = this.user.roles;
                    }
                    this.approval.emailOfPersonThatNeedsApproval = this.user.email;
                    this.approval.approverId = this.authenticatedUserId;
                    this.approval.organizationId = this.organizationId;
                    this.approval.expirationDate = this.user.expirationDate;

                    try {
                        let updateRes = await this.updateProfile(roles);

                        console.log("err result: " + updateRes)

                        // if update breaks break everything
                        if ((updateRes && !updateRes.status) || !updateRes) throw Error("an error occurred cannot continue" + updateRes);

                        await this.approveUser(this.approval);

                    }
                    catch (err) {
                    }
                    finally {
                        //make sure to update the user first
                        await this.getUser(this.id);
                        this.modals.notice = false;
                    };
                }
                else console.log("validation failed")
            });
        },
        reject(e) {
            let ctx = this;
            this.$validator.validateAll().then((result) => {
                if (result) {
                    let roles = null;
                    if (this.user) {
                        roles = this.user.roles;
                    }
                    this.approval.organizationId = this.organizationId;
                    ctx.rejectUser(ctx.approval).then((response) => {
                        ctx.getUser(ctx.id).then(() => {
                        })
                    }).catch((err) => {
                        this.$toast.error(err.response.data.message);
                    }).finally(()=>{
                          ctx.modals.notice = false;
                    });
                }
            });
        },
        async updateProfile(roles) {
            let ctx = this;
            if (!Util.isNull(this.user)) {
                this.user.roles = roles;
            }

            // try to catch the error
            try {
                return await ctx.updateUser();
            } 
            catch (error) {
                throw error;
            }

        },
        getError(fieldName) {
            return this.errors.first(fieldName);
        },

    },
};
</script>